module.exports = __webpack_public_path__ + "img/capsulas.50aaa476.png";